import clsx from 'clsx';

import Checkbox from '@components/checkbox/Checkbox';

import { CustomTableHeaderProps } from './types';

interface CustomTableRowProps {
  headers: CustomTableHeaderProps[];
  data: {
    [key: string]: any;
  }[];
  handleSelect: (row: any) => void;
  selectedRows?: (string | number)[];
  hasMultiSelect?: boolean;
  handleCheckboxSelect?: (row: any) => void;
  disabledRowIds?: string[];
}

const CustomTableRow = ({
  headers,
  data,
  handleSelect,
  selectedRows,
  hasMultiSelect,
  handleCheckboxSelect,
  disabledRowIds
}: CustomTableRowProps) => {
  const getClassName = (item: any) =>
    clsx(
      'flex min-h-12.5 w-full items-center justify-between rounded-lg border border-cofeeNeutral4 px-4 py-2 hover:bg-cofeeHoverBlue',
      selectedRows?.includes(item.id)
        ? 'bg-cofeeGreyBlue100'
        : 'bg-cofeeNeutral1',
      disabledRowIds?.includes(item.id)
        ? 'cursor-not-allowed !bg-cofeeGreyNeutral4'
        : ''
    );

  return (
    <div className="mt-2 flex min-h-40 w-full flex-col gap-y-2">
      {data.map((item) => (
        <div
          key={item.id}
          className={getClassName(item)}
          onClick={() => handleSelect(item)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleSelect(item);
            }
          }}
        >
          {hasMultiSelect && (
            <div className="w-5">
              <Checkbox
                handleChange={() => handleCheckboxSelect?.(item)}
                isChecked={selectedRows?.includes(item.id)}
                disabled={disabledRowIds?.includes(item.id)}
              />
            </div>
          )}
          {headers.map((header) => (
            <div
              key={`${item.id}-${header.accessor}`}
              style={{ width: header.width }}
              className={clsx(
                'px-2 text-base font-medium',
                disabledRowIds?.includes(item.id)
                  ? 'text-cofeeNeutral6'
                  : 'text-cofeeNeutral10'
              )}
            >
              {item[header.accessor]}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default CustomTableRow;
